import React from 'react';
import { Phone, MapPin, Mail, Clock, Building2, Users } from 'lucide-react';
import { mockData } from '../mock';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-slate-900 via-slate-800 to-blue-900 text-white">
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-10">
          {/* Company Info - takes more space */}
          <div className="space-y-6 lg:pr-6">
            <div className="flex items-center space-x-4">
              <img 
                src="/images/logo.jpeg" 
                alt="BS Devis&Plan" 
                className="w-16 h-16 rounded-xl object-cover"
              />
              <div>
                <h3 className="text-2xl font-bold">{mockData.company.name}</h3>
                <p className="text-blue-200 text-sm">Bureau d'études BTP</p>
              </div>
            </div>
            
            <p className="text-slate-300 leading-relaxed">
              Bureau d'études spécialisé en devis 2D/3D, chiffrage bâtiment et architecture d'intérieur. Nous vous accompagnons de la conception au suivi de chantier en partenariat avec Constriva pour le gros œuvre.
            </p>

            <div className="flex items-center space-x-3 pt-2">
              <button 
                onClick={() => window.location.href = 'tel:0650242913'}
                className="inline-flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-300 hover:scale-105"
              >
                <Phone className="w-4 h-4" />
                <span>Nous appeler</span>
              </button>
            </div>
          </div>

          {/* Contact */}
          <div className="space-y-6">
            <h4 className="text-xl font-bold">Contact</h4>
            
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <div className="text-slate-300 text-sm">
                  {mockData.company.contact.address}
                </div>
              </div>

              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a 
                  href="tel:0650242913"
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  {mockData.company.contact.phone}
                </a>
              </div>

              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-blue-400 flex-shrink-0" />
                <a 
                  href={`mailto:${mockData.company.contact.email}`}
                  className="text-slate-300 hover:text-white transition-colors"
                >
                  {mockData.company.contact.email}
                </a>
              </div>

              <div className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-blue-400 mt-0.5 flex-shrink-0" />
                <div className="text-slate-300 text-sm">
                  <p>Lun - Ven: {mockData.company.contact.hours.weekdays}</p>
                  <p>Sam - Dim: Fermé</p>
                </div>
              </div>
            </div>
          </div>

          {/* Partenaire Constriva */}
          <div className="space-y-4">
            <h4 className="text-xl font-bold flex items-center space-x-2">
              <Users className="w-5 h-5 text-blue-400" />
              <span>Notre Partenaire</span>
            </h4>

            <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-4">
              <div className="flex items-center space-x-3 mb-2">
                <div className="w-9 h-9 bg-gradient-to-br from-blue-600 to-slate-700 rounded-lg flex items-center justify-center flex-shrink-0">
                  <span className="text-white font-bold text-sm">C</span>
                </div>
                <div>
                  <h5 className="font-bold text-white text-sm leading-tight">Constriva</h5>
                  <p className="text-blue-200 text-xs">Noiseau (94880)</p>
                </div>
              </div>
              <p className="text-slate-300 text-xs mb-3 leading-relaxed">
                Partenaire BTP — maçonnerie & gros œuvre en Val-de-Marne
              </p>
              <div className="rounded-lg overflow-hidden border border-white/10">
                <iframe
                  title="Constriva - Noiseau"
                  src="https://www.google.com/maps?q=4+Rue+du+President+Kennedy+94880+Noiseau&output=embed"
                  width="100%"
                  height="140"
                  style={{ border: 0 }}
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=4+Rue+du+President+Kennedy+94880+Noiseau"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block mt-3 text-blue-400 hover:text-blue-300 text-xs font-medium transition-colors"
              >
                Itinéraire vers Constriva →
              </a>
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-white/20 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-slate-400 text-sm">
              © {currentYear} {mockData.company.name}. Tous droits réservés.
            </div>
            
            <div className="flex space-x-6 text-sm">
              <button className="text-slate-400 hover:text-white transition-colors">
                Mentions légales
              </button>
              <button className="text-slate-400 hover:text-white transition-colors">
                Politique de confidentialité
              </button>
              <button className="text-slate-400 hover:text-white transition-colors">
                CGV
              </button>
            </div>
          </div>

          <div className="text-center mt-6 pt-6 border-t border-white/10"></div>
        </div>
      </div>
    </footer>
  );
};